// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__m8pcL","productName":"Table_productName__-iYk8"};